import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class EngineCriteria extends BasicCriteria {
kind: string;
visionCode: string;
}

